// extracted by mini-css-extract-plugin
module.exports = {"bar":"MenuButton-module--bar--3dtLl","wrapper":"MenuButton-module--wrapper--2kx3u","container":"MenuButton-module--container--2Pf9p","open":"MenuButton-module--open--3Ophk"};